<mat-form-field class="indent-item">
  <mat-label>Uploaded file</mat-label>
  <mat-select placeholder="Uploaded file" (selectionChange)="selectedUploadedFile($event)">
    @for (file of uploadedFile$ | async; track file) {
      <mat-option [value]="file">{{ file }}</mat-option>
    }
  </mat-select>
</mat-form-field>